// extracted by mini-css-extract-plugin
export default {"fillTextPrimary":"fillTextPrimary__dd_D_","fillBackgroundPrimary":"fillBackgroundPrimary__tKYZV"};